module.exports = __webpack_public_path__ + "img/momo_layout_bottom_left.f4896fa1.png";